// extracted by mini-css-extract-plugin
export default {"AddButton":"MaterialsList_AddButton__gL+Im","Card":"MaterialsList_Card__N3aNv","Table":"MaterialsList_Table__a8Cfg","Paper":"MaterialsList_Paper__VxP0z"};